import { reactive, readonly } from 'vue';
import type { CorePageStoryblok } from '~/types/storyblok-generated';
import { moduleSettingsMap, type ModuleSettings, type ModuleTheme } from '~/utils/module-settings';
import { getThemeOfModule } from '~/utils/theme';

type Module = NonNullable<CorePageStoryblok['body']>[number];

const state = reactive<{
  theme: ModuleTheme;
  name: string;
  currentModule: Module | null;
  moduleSettings: ModuleSettings | null;
}>({
  theme: 'brown-light',
  name: '',
  currentModule: null,
  moduleSettings: null,
});

const exposedState = readonly(state);

export function useCurrentModule() {
  function clearCurrentModule() {
    state.name = '';
  }

  function setCurrentModule(currentModule: Module) {
    state.currentModule = currentModule;

    /**
     * Module settings
     */
    state.moduleSettings = moduleSettingsMap[currentModule.component] ?? null;

    /**
     * Theme
     */
    state.theme = getThemeOfModule(currentModule);

    /**
     * Name
     */
    state.name = currentModule.component;
  }

  return {
    state: exposedState,
    setCurrentModule,
    clearCurrentModule,
  };
}
